var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',{attrs:{"nav":"","shaped":""}},_vm._l((_vm.navigation),function(item,index){return _c('div',{key:index},[_c('menu-item',{staticClass:"nav-item",attrs:{"menuItem":item}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }